export enum Type {
    Website = "website",
}
